import AbstractExpressGateway from './AbstractExpressGateway';

class ApplePayGateway extends AbstractExpressGateway {

    type = 'applePay';

    constructor(props) {
        super(props);
        this.capabilities = [
            ...this.capabilities,
            'button_theme',
            'button_type',
            'form_validation'
        ];
    }
}

export default ApplePayGateway;